import React from 'react'
import 'regenerator-runtime/runtime'
import dynamic from 'next/dynamic'
import Head from 'next/head'

const DesignerApp = dynamic(() => import('../../routes/Designs'), {
  ssr: false
})

const Routes = () => {
  return (
    <>
      <Head>
        <title>Room Design App | Discover The Leading Home & Interior Design App - DecorMatters</title>
        <meta
          name="description"
          content="Explore the best room design app at DecorMatters. This virtual staging home design app is perfect for interior designers and anyone that wants to plan a room design online. Browse our website to find home furniture and sign up for our interior design app at DecorMatters."
        />
        <meta name="twitter:title" content="Room Design App | Discover The Leading Home & Interior Design App - DecorMatters" />
        <meta property="og:title" content="Room Design App | Discover The Leading Home & Interior Design App - DecorMatters" />
        <meta
          property="og:description"
          content="Explore the best room design app at DecorMatters. This virtual staging home design app is perfect for interior designers and anyone that wants to plan a room design online. Browse our website to find home furniture and sign up for our interior design app at DecorMatters."
        />
        <meta property="og:site_name" content="DecorMatters" />
        <meta name="google-site-verification" content="tc8tm4ArNtKEDRKnlRcx3Yci9kajD8h5x1vtRdrbOM0" />
      </Head>
      <DesignerApp />
    </>
  )
}

export default Routes
